import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";


import {
    Form, Input, FormFeedback, Label, Modal, ModalHeader, ModalBody,
} from "reactstrap";

//redux
import { useSelector, useDispatch } from "react-redux";
import toastr from "toastr";

// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";

// actions
import { addParticipantsInvitesText, editParticipantsInvitesText } from "store/actions";
import { fetchLanguageList } from "helpers/backend_api_helper";
import { useLocation } from "react-router-dom";
import { withTranslation } from "react-i18next";

const TextAddEditModal = props => {
    const { modal, toggle, isEdit, itemData, fetchParticipantsInvitesTextListData, tableData } = props
    const [participantsInvitesTextData, setParticipantsInvitesTextData] = useState();
    const [languageList, setLanguageList] = useState()
    const { state } = useLocation();
    // add text
    const [inputSubject, setInputSubject] = useState('');

    const handleAddUp = (text) => {
      setInputSubject((prevValue) => prevValue + `{${text}}`);
    };
  
    const handleDue = (text) => {
      setInputSubject((prevValue) => prevValue + `{${text}}`);
    };
  
    const handleChange = (e) => {
      setInputSubject(e.target.value);
    };


    const { error, success, loading,editLoading } = useSelector(state => ({
        loading: state.ParticipantsInvites.loading,
        error: state.ParticipantsInvites.error,
        success: state.ParticipantsInvites.success,
        editLoading:state?.ParticipantsInvites?.editLoading

    }));
    const dispatch = useDispatch();

    useEffect(() => {
        setParticipantsInvitesTextData(itemData)
        setInputSubject(itemData?.body || '')
    }, [itemData])

    // fetch language
    const fetchLanguageLists = async () => {
        const listLang = await fetchLanguageList();
        setLanguageList(listLang?.data)
    }

    useEffect(() => {
        fetchLanguageLists()
    }, [])

    const validation = useFormik({
        enableReinitialize: true,

        initialValues: {
            subject: participantsInvitesTextData?.subject || '',
            body: participantsInvitesTextData?.body || '',
            language_id: participantsInvitesTextData?.language_id || languageList && languageList[0]?.id,
            is_active: participantsInvitesTextData?.is_active || 'Y'
        },
        validationSchema: Yup.object({
            subject: Yup.string().required(props.t("Please Enter Invitation Subject")),
            // body: Yup.string().required(props.t("Please Enter Invitation Text")),
            language_id: Yup.string().required(props.t("Please Enter Language")),
            is_active: Yup.string().required(props.t("Please Enter Text Status")),
            
        }),
        onSubmit: (values, { resetForm }) => {
            values = {
                ...values,
                invitation_id: state?.participantsInvitesData?.id,
                body: inputSubject
            }
            if (isEdit) {
                const languageExists = tableData?.invites?.some(item => item.language_id == Number(values.language_id) && values.language_id != itemData.language_id);
                if(languageExists){
                    return toastr.error("Invitation subject text already exists with the selected language.")
                }
                dispatch(editParticipantsInvitesText(values, participantsInvitesTextData?.id, (res) => {
                    if (res.status === 'success') {
                        toastr.success(res.message)
                        
                        resetForm({
                            subject: '',
                            body: '',
                            language_id: '',
                            is_active: ''
                        });
                        fetchParticipantsInvitesTextListData()
                        toggle()

                    } else {
                        toastr.error(res.message)
                        toggle()
                        
                    }
                }));
            } else {
                const languageExists = tableData?.invites?.some(item => item.language_id == values.language_id);
                if(languageExists){
                    return toastr.error("Invitation subject text already exists with the selected language.")
                }
                dispatch(addParticipantsInvitesText(values, props?.router?.navigate, (res) => {
                    if (res?.status === 'success') {
                        toastr.success(res.message)
                        
                        resetForm({
                            subject: '',
                            body: '',
                            language_id: '',
                            is_active: ''
                        });
                        fetchParticipantsInvitesTextListData()
                        toggle()
                    } else {
                        toastr.error(res.message)
                        toggle()
                        
                    }
                }));
            }
        }
    });


  
    return (
        <React.Fragment>
            <Modal isOpen={modal} toggle={
                () => {
                    toggle()
                    
                }}>
                <ModalHeader tag="h4" toggle={
                    () => {
                        toggle()
                        
                    }}>
                    {!!isEdit ? props.t("Edit Invitation Subject") : props.t("Add Invitation Subject")}
                </ModalHeader>
                <ModalBody>
                    <Form
                        className="form-horizontal"
                        onSubmit={(e) => {
                            e.preventDefault();
                            validation.handleSubmit();
                            return false;
                        }}
                    >
                        <div className="mb-3 d-block">
                            <Label className="form-label m-0 pb-1">{props.t("Invitation Subject")}:</Label>

                            <Input
                                type="text"
                                name="subject"
                                placeholder={props.t("Enter Invitation Subject")}
                                value={validation.values.subject || ""}
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                invalid={validation.touched.subject && validation.errors.subject ? true : false}
                            >
                            </Input>

                            {validation.touched.subject && validation.errors.subject ? (
                                <FormFeedback type="invalid">{validation.errors.subject}</FormFeedback>
                            ) : null}
                        </div>
                        <div className="mb-3 d-block">
                            <Label className="form-label m-0 pb-1">{props.t("Invitation Text")}:</Label>

                            <Input
                                type="textarea" 
                                value={inputSubject} 
                                onChange={handleChange}
                                placeholder={props.t("Enter Invitation Text")}

                            >
                            </Input>
                            <div className="btn-login-admin mt-3 batches-add-modal-btn">
                                <div>
                                    <span className="btn btn-primary btn-block" onClick={() => handleAddUp('up')}>{`add{up}`}</span>
                                    <p className="mt-2"><b>{props.t(`Note : Please add {up} for provide user name password.`)}</b></p>
                                </div>
                                <div>
                                    <span className="btn btn-primary btn-block mt-3" onClick={() => handleDue(' add_down')}>{`add{due}`}</span>
                                    <p className="mt-2"><b>{props.t(`Note : Please add {due} for provide batch end date.`)}</b></p>
                                </div>
                            </div>
                        </div>

                        <div className="mb-3 d-block">
                            <Label className="form-label m-0 pb-1">{props.t("Language")}:</Label>
                            <Input
                                name="language_id"
                                className="form-control"
                                type="select"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.language_id || ""}
                                invalid={
                                    validation.touched.language_id && validation.errors.language_id ? true : false
                                }
                            >
                                <option value="" disabled>{props.t("Select Language")}</option>
                                {
                                    languageList?.map((data, key) => {
                                        return (
                                            <option key={key} value={data?.id}>{data?.label}</option>
                                        )
                                    })
                                }
                            </Input>
                            {validation.touched.language_id && validation.errors.language_id ? (
                                <FormFeedback type="invalid">{validation.errors.language_id}</FormFeedback>
                            ) : null}
                        </div>


                        <div className="mb-3 d-flex align-items-center gap-3">
                            <Label className="form-label m-0">{props.t("Status")}:</Label>
                            <div className="d-flex align-items-center gap-2">
                                <Input
                                    id="yes"
                                    name="is_active"
                                    type="radio"
                                    checked={validation.values.is_active === 'Y'}
                                    value="Y"
                                    onClick={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    invalid={
                                        validation.touched.is_active && validation.errors.is_active ? true : false
                                    }
                                />
                                <Label for="yes" className="form-label m-0">{props.t("Active")}</Label>
                                <Input
                                    id="no"
                                    name="is_active"
                                    checked={validation.values.is_active === 'N'}
                                    value="N"
                                    type="radio"
                                    onClick={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    invalid={
                                        validation.touched.is_active && validation.errors.is_active ? true : false
                                    }
                                />
                                <Label for="no" className="form-label m-0">{props.t("In-Active")}</Label>

                            </div>
                            {validation.touched.is_active && validation.errors.is_active ? (
                                <FormFeedback type="invalid">{validation.errors.is_active}</FormFeedback>
                            ) : null}
                        </div>


                        {
                            editLoading ?
                                <div className="btn-login-admin mt-3 batches-add-modal-btn">

                                    <button
                                        type="button"
                                        className="btn btn-primary btn-block d-flex"
                                        disabled
                                    >
                                        <i className="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>{" "}

                                        {props.t("Submit")}
                                    </button>
                                </div>
                                :
                                <div className="btn-login-admin mt-3 batches-add-modal-btn">
                                    <button
                                        className="btn btn-primary btn-block"
                                        type="submit"
                                    // disabled
                                    >
                                        {props.t("Submit")}
                                    </button>
                                </div>
                        }


                    </Form>
                </ModalBody>

            </Modal>

        </React.Fragment>
    );
};

TextAddEditModal.propTypes = {
    history: PropTypes.object,
    t: PropTypes.any,

};
export default withTranslation()(TextAddEditModal);
